import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Clock, AlertTriangle } from 'lucide-react';

interface SessionTimeoutWarningProps {
  timeLeft: number;
  onExtend: () => void;
  show: boolean;
}

export function SessionTimeoutWarning({ timeLeft, onExtend, show }: SessionTimeoutWarningProps) {
  if (!show) return null;

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="fixed top-4 right-4 z-50 w-96">
      <Alert variant="destructive" className="border-orange-500 bg-orange-50 dark:bg-orange-900/20">
        <AlertTriangle className="h-4 w-4" />
        <AlertDescription className="flex items-center justify-between">
          <div>
            <p className="font-medium">Sesión por expirar</p>
            <p className="text-sm flex items-center gap-1 mt-1">
              <Clock className="h-3 w-3" />
              {minutes}:{seconds.toString().padStart(2, '0')} restantes
            </p>
          </div>
          <Button 
            size="sm" 
            onClick={onExtend}
            className="ml-4"
          >
            Extender
          </Button>
        </AlertDescription>
      </Alert>
    </div>
  );
}